module.exports = __webpack_public_path__ + "img/WAXING_GIBBOUS.71aa5b12.png";